var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpload(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#595959"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M1.275 6.031l-.947.963c-.209.21-.327.496-.328.794v1.458c0 .933.745 1.69 1.663 1.69h9.979c.919 0 1.664-.757 1.664-1.69V7.788c-.002-.298-.12-.584-.328-.794l-.948-.963M3.16 3.58L6.653 0 10.145 3.58",
    transform: "translate(-153 -576) translate(121 565) translate(32 11) translate(0 2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.65 8.086L6.655 0",
    transform: "translate(-153 -576) translate(121 565) translate(32 11) translate(0 2)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.c7d59c8a.svg";
export { ForwardRef as ReactComponent };